export const FETCH_PRO_REQUEST = 'pros/pro/FETCH_REQUEST';
export const FETCH_PRO_SUCCESS = 'pros/pro/FETCH_SUCCESS';
export const FETCH_PRO_FAILURE = 'pros/pro/FETCH_FAILURE';
export const FETCH_PROS_REQUEST = 'pros/FETCH_REQUEST';
export const FETCH_PROS_SUCCESS = 'pros/FETCH_SUCCESS';
export const FETCH_PROS_FAILURE = 'pros/FETCH_FAILURE';
export const NEXT_PROS_PAGE = 'pros/NEXT_PAGE';

export const RESET = 'pros/RESET';


// WEBPACK FOOTER //
// ./src/modules/pros/actionTypes.js